module.exports = __webpack_public_path__ + "static/media/cold.ea49f1fb.png";